import { render, staticRenderFns } from "./SubNavbar.vue?vue&type=template&id=1a0323a3&scoped=true"
import script from "./SubNavbar.vue?vue&type=script&lang=ts"
export * from "./SubNavbar.vue?vue&type=script&lang=ts"
import style0 from "./SubNavbar.vue?vue&type=style&index=0&id=1a0323a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0323a3",
  null
  
)

export default component.exports